$(document).ready(function(){
   $(".slide-nav li button.slide-nav__button").click(function(){
   $("body").addClass("mobile-sub-active");
  });

  $(".mobile-nav-trigger").click(function(){
   $(".overlay-header__drawers").toggleClass("overlay-active");
   $("html").addClass("lock-scroll");
   $("html").addClass("custom_drawer-close");
  });
  
   $(".site-nav_cartTrigger").click(function(){
   $(".overlay-header__drawers").toggleClass("overlay-active");
   $("html").addClass("custom_drawer-close");
  });

  $(".js-close-header-cart").click(function(){
  $(".overlay-header__drawers").removeClass("overlay-active");
   setTimeout(function() {
      $("html").removeClass("custom_drawer-close");
    }, 500); 
  });
  
   $(".overlay-header__drawers").click(function(){
   $(this).removeClass("overlay-active");
   $("html").removeClass("lock-scroll");
    setTimeout(function() {
      $("html").removeClass("custom_drawer-close");
    }, 500);  
  });
  
  $(" .back-submenu").click(function(){
   $("body").removeClass("mobile-sub-active"); 
  });
  
  $(".js-close-icon-hamburger").click(function(){
   $(this).toggleClass("hamburger-active");
   $(".mobile-nav-trigger").trigger("click");
   $("html").removeClass("lock-scroll");
   setTimeout(function() {
     $("html").removeClass("custom_drawer-close");
    }, 500);
  });
  
   $(".js-search-header-custom").click(function(event){
     event.preventDefault()
     event.stopPropagation()
     $(".site-header_search-custom").toggleClass("is-active");
     $(".site-header_search-custom").find(".site-header__search-container").toggleClass("is-active");
     $(".site-header_search-custom").find(".site-header__search-container").find(".site-header__search-form").toggleClass("is-active"); 
  });

   $(".pre-order-cart-close").click(function(){
     $(this).parents(".pre-order-cart-notify").removeClass("active");
     $(".pre-order-cart-notify-overlay").removeClass("active");
   });
    
   $(".pre-order-cart-notify-overlay").click(function(){
     $(".pre-order-cart-notify").removeClass("active"); 
     $(this).removeClass("active");
   });
  
});

// custom cart drawer notification for pre_order product
//$(document).ready(checkCont);
   function checkCont() {
    var getcount = $(".cart__drawer-form .cart__item").length;
    //console.log(getcount); 
    var metacount = $("#preorder-meta_val").attr("value");
     //console.log(metacount); 
    
    if ( getcount >= 2  && metacount )
    {
     $(".pre-order-cart-notify").addClass("active");
     $(".pre-order-cart-notify-overlay").addClass("active");
     // console.log("2");
    }
    else
    {
      $(".pre-order-cart-notify").removeClass("active");
     $(".pre-order-cart-notify-overlay").removeClass("active");
     // console.log("less 2");
      setTimeout(checkCont, 50); //wait 50 ms, then try again
    }
 }